import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useAnnouncements = (options = {}) => {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: async () => {
      const response = await api.get('/announcements?limit=10');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options
  });
};

